import React, { useEffect } from 'react'
import { Row, Tab, Tabs, useStatusOverlay } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import StoryGallery from '../StoryGallery/StoryGallery'
import StoryTextForm from '../StoryTextForm/StoryTextForm'
import useGalleryStories from '../../../../../hooks/useGalleryStories/useGalleryStories'
import { useStoryManager } from '../../../../../providers/StoryProvider'

export default function StoryTabs({ size = 'quarter' }) {
  const [t] = useTranslation()
  const { storyState, setTab } = useStoryManager()
  const { currentTab } = storyState
  const { stories, loading, error } = useGalleryStories()
  const showStatusOverlay = useStatusOverlay()

  useEffect(() => {
    if (error) {
      showStatusOverlay({
        message: t('StoryTabs.somethingWentWrong', 'Something went wrong! Please try again later.'),
        type: 'error',
      })
    }
  }, [error, showStatusOverlay, t])

  if (loading) {
    return (
      <Row alignX="center" alignY="middle">
        <NoticeLoading size="lg" />
      </Row>
    )
  }

  return (
    <Tabs fullWidth index={currentTab} onChange={(index) => setTab(index)}>
      <Tab title={t('TextPicker.editStory.label', 'Edit Story')}>
        <StoryTextForm size={size} />
      </Tab>
      <Tab title={t('TextPicker.selectFormGallery.label', 'Select from Memories Gallery')}>
        <StoryGallery size={size} stories={stories} />
      </Tab>
    </Tabs>
  )
}
